import {
  OrchestrationDispatchCommandError,
  type OrchestrationDispatchDisposition,
  type OrchestrationDispatchErrorCode,
} from "@t3tools/contracts";
import * as Schema from "effect/Schema";

const isDispatchCommandError = Schema.is(OrchestrationDispatchCommandError);

/**
 * Reads the transient disposition attached to a dispatch failure.
 *
 * The value describes only the current RPC. It must never be persisted or
 * interpreted as durable Provider admission state.
 */
export function orchestrationDispatchDisposition(
  error: unknown,
): OrchestrationDispatchDisposition | null {
  return isDispatchCommandError(error) ? (error.disposition ?? null) : null;
}

/** Returns a stable, wire-safe code for a dispatch failure when one is available. */
export function orchestrationDispatchErrorCode(
  error: unknown,
): OrchestrationDispatchErrorCode | null {
  return isDispatchCommandError(error) ? (error.code ?? null) : null;
}

/** True only when the server confirms that bootstrap created the Product Thread. */
export function orchestrationDispatchRetainedThread(error: unknown): boolean {
  return isDispatchCommandError(error) && error.retainedThread === true;
}
